module.exports = __webpack_public_path__ + "static/island-cd07b85eb1fb7ee4499fa59de50fc3d5.jpg";